import React from "react";

const CAT_LABELS = {
  story: "Story", evidence: "Evidence", revenue: "Revenue",
  relationship: "Relationship", infrastructure: "Infrastructure",
};

export const CategoryBars = ({ scores = {}, labels = CAT_LABELS }) => {
  const entries = Object.entries(scores).filter(([, v]) => v !== null && v !== undefined);
  return (
    <div className="space-y-4" data-testid="category-bars">
      {entries.map(([key, val]) => {
        const color = val >= 70 ? "#4A5D23" : val >= 55 ? "#C5A059" : val >= 40 ? "#B87333" : "#9A3B2E";
        return (
          <div key={key}>
            <div className="flex justify-between items-baseline mb-1.5">
              <span className="text-sm font-medium text-navy font-display">{labels[key] || key}</span>
              <span className="text-sm font-semibold text-charcoal tabular-nums">{val}<span className="text-muted-foreground text-xs">/100</span></span>
            </div>
            <div className="h-2.5 bg-line rounded-full overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${val}%`, background: color, transition: "width 1s ease" }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
